import {
  AdminControlUpdateRequest,
  AdminRecordModel,
  AdminControlUpdateResponse,
} from '../../types.ts';
import { AdminQueryValues } from '../../enums/adminQueryParametersEnum.ts';
import {
  httpFetch,
  httpFetchJson,
} from '../../../../core/services/api/httpClient.ts';

const getAdministrationParameterUrl = (keyParameter: string): string => {
  const params = new URLSearchParams({ key_parameter: keyParameter });
  return `/api/get_administration_parameter?${params.toString()}`;
};

/**
 * Retrieves the banner message administration setting.
 */
const getBannerMessage = async (): Promise<AdminRecordModel> => {
  return httpFetchJson<AdminRecordModel>(
    getAdministrationParameterUrl('Banner'),
    { withBackendAuth: true }
  );
};

/**
 * Retrieves the landing page message administration setting.
 */
const getLandingMessage = async (): Promise<AdminRecordModel> => {
  return httpFetchJson<AdminRecordModel>(
    getAdministrationParameterUrl('Landing'),
    { withBackendAuth: true }
  );
};

/**
 * Returns true when the current user is configured as an administrator.
 */
const isCurrentUserIsAdmin = async (): Promise<boolean> => {
  const response = await httpFetch(
    getAdministrationParameterUrl('Administrator'),
    { withBackendAuth: true }
  );
  if (response.status === 204) {
    return false;
  }

  const data = (await response.json()) as AdminRecordModel;
  return !!data.email;
};

/**
 * Returns true when the current user is configured as a function admin.
 */
const isCurrentUserIsFunctionAdmin = async (): Promise<boolean> => {
  const response = await httpFetch(
    getAdministrationParameterUrl('FunctionAssistantAdministrator'),
    { withBackendAuth: true }
  );
  if (response.status === 204) {
    return false;
  }

  const data = (await response.json()) as AdminRecordModel;
  return !!data.email;
};

/**
 * Updates administration settings for the selected parameter key.
 */
const updateAdministratorSettings = async (
  adminSettings: AdminControlUpdateRequest
): Promise<AdminControlUpdateResponse> => {
  return httpFetchJson<AdminControlUpdateResponse>(
    '/api/update_administration_parameter',
    {
      method: 'POST',
      withBackendAuth: true,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(adminSettings),
    }
  );
};

/**
 * Retrieves an administration parameter and maps HTTP 204 to false.
 */
const getAdminParameters = async (
  keyParameter: AdminQueryValues
): Promise<AdminRecordModel | boolean> => {
  const response = await httpFetch(
    getAdministrationParameterUrl(keyParameter),
    {
      withBackendAuth: true,
    }
  );

  if (response.status === 204) {
    return false;
  }

  return (await response.json()) as AdminRecordModel | boolean;
};
export const administratorApi = {
  getBannerMessage,
  getLandingMessage,
  isCurrentUserIsAdmin,
  isCurrentUserIsFunctionAdmin,
  updateAdministratorSettings,
  getAdminParameters,
};
